// extracted by mini-css-extract-plugin
export default {"layout":"CompanyLayout_layout__aYc8l","main":"CompanyLayout_main__rvCMA","content":"CompanyLayout_content__d9f9G"};